import { DepositBanner as DSDepositBanner } from '@awazevr/design-system.components.deposit-banner'
import type { Deposit } from '@awazevr/mfe-common.configs.brand'
import type { FormattedAmount } from '@awazevr/mfe-common.utils.locale-formatting'

export type DepositBannerTranslations = {
  reserveTodayForOnly: string
  reserveForSelectedProperties: string
}

export type DepositBannerProps = {
  activeDepositScheme?: Partial<Deposit> | null
  translations: DepositBannerTranslations
  formatCurrency: (value: number) => FormattedAmount
  showTermsMessage?: boolean
}

const formatDepositAmount = (
  activeDepositScheme: Partial<Deposit> | null | undefined,
  formatCurrency: (value: number) => FormattedAmount,
): string => {
  if (!activeDepositScheme?.amount) return ''

  if (activeDepositScheme.unitType === 'percentage') {
    return `${activeDepositScheme.amount}%`
  }

  const activeDepositAmount = formatCurrency(activeDepositScheme.amount)
  let currencyString = ''
  if (activeDepositAmount.currencySignPosition === 'before')
    currencyString += activeDepositAmount.currencySign
  currencyString += activeDepositAmount.formattedAmount
  if (activeDepositAmount.currencySignPosition === 'after')
    currencyString += activeDepositAmount.currencySign

  return currencyString
}

export const DepositBanner = ({
  activeDepositScheme,
  translations,
  formatCurrency,
  showTermsMessage = true,
}: DepositBannerProps) => {
  if (!activeDepositScheme) return null

  const formatted = formatDepositAmount(activeDepositScheme, formatCurrency)

  return (
    <DSDepositBanner
      highlightedMessage={`${translations.reserveTodayForOnly} ${formatted}`}
      termsMessage={
        showTermsMessage ? translations.reserveForSelectedProperties : ''
      }
    />
  )
}
